import React__default, { memo } from 'react';
import { Lens } from 'emotion-icons/material';
import Link from '../Link/index.js';
import { Table as Table$2, THead, THLabel, THTopSticky, THSideSticky, TD } from './ChannelLineup.styles.js';

var Table = /*#__PURE__*/memo(function (_ref) {
  var packages = _ref.packages,
    channels = _ref.channels;
  return /*#__PURE__*/React__default.createElement(Table$2, {
    className: "leshen-channel-lineup-table"
  }, /*#__PURE__*/React__default.createElement(THead, {
    className: "thead"
  }, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement(THLabel, {
    className: "thlabel"
  }, "Channels"), packages.map(function (packageItem) {
    return /*#__PURE__*/React__default.createElement(THTopSticky, {
      key: packageItem.node.name,
      className: "th-top-sticky"
    }, packageItem.node.name);
  }))), /*#__PURE__*/React__default.createElement("tbody", null, channels.map(function (_ref2) {
    var channel = _ref2.node;
    return /*#__PURE__*/React__default.createElement("tr", {
      key: channel.name
    }, /*#__PURE__*/React__default.createElement(THSideSticky, {
      className: "th-side-sticky"
    }, channel.url ? /*#__PURE__*/React__default.createElement(Link, {
      to: channel.url
    }, channel.name) : channel.name), packages.map(function (_ref3) {
      var packageItem = _ref3.node;
      return /*#__PURE__*/React__default.createElement(TD, {
        key: packageItem.brandy_id,
        className: "td"
      }, channel.packageAvailability.includes(packageItem.brandy_id) && /*#__PURE__*/React__default.createElement(Lens, {
        size: "0.75em",
        className: "disc"
      }));
    }));
  })));
});
var Table$1 = Table;

export { Table$1 as default };
//# sourceMappingURL=Table.js.map
